import { Grid, Tabs, Tab } from "@mui/material";
import { observer } from "mobx-react";
import { styled } from "@mui/material/styles";
import React from "react";
import { useRootStore } from "store/StoreContextProvider";
import AdvicePageStore from "../store/AdvicePageStore";

const CustomTabs = styled(Tabs)`
  color: #ababab;

  .css-1a4240h-MuiButtonBase-root-MuiTab-root.Mui-selected {
    color: #000000;
  }
`;

const CustomTab = styled(Tab)`
  color: #ababab;

  & .Mui-selected {
    color: #000000;
  }
`;

interface Props {
  pageStore: AdvicePageStore;
}

function AdviceTopTabs(props: Props) {
  const { loginStore } = useRootStore();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    props.pageStore.setTabValue(newValue);
    props.pageStore.fetchTargetsByDeptCode(loginStore.currentUser);
  };
  return (
    <Grid container item direction="column" rowGap={2}>
      <CustomTabs
        value={props.pageStore.tabValue}
        onChange={handleChange}
        variant="fullWidth"
        aria-label="topTabs_Home"
        TabIndicatorProps={{
          sx: {
            background: "black",
          },
        }}
      >
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"downwards"}
          label="Downwards"
        />
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"peer"}
          label="Peer"
        />
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"all"}
          label="All"
        />
      </CustomTabs>
    </Grid>
  );
}

export default observer(AdviceTopTabs);
